// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"scrollable-container_scrollableContainer__9Dcpk","content":"scrollable-container_content__PvKZR","description":"scrollable-container_description__BYNW5"};